import React, {useRef, useState} from 'react'
import {getTailwindPositions} from './helpers'

interface Props {
  /**
   * What is the tip? This will be shown on mouse hover
   */
  tip: string | React.ReactElement
  /**
     /**
     * This is an icon element. default is exclamation mark in a circle.
     */
  icon?: React.ReactNode
  /**
   * This is for extra information without requirement of mouse hover?
   */
  children?: React.ReactNode
  /**
   * !! DEPRECATED, What is the comment? This will be shown on mouse hover
   */
  // comment: string;

  className: String

  position?: string
}

export const QuickTip = ({
  className,
  icon = <i className="icon-info-circled text-sm" />,
  // comment,
  tip,
  children,
  position = 'top',
}: Props) => {
  const [hover, setHover] = useState(false)
  const ref = useRef(null)
  const toggleMouseHover = () => setHover(!hover)

  const positions = getTailwindPositions(position)
  const colReverse = positions.match(/bottom/) ? 'flex-col' : 'flex-col-reverse'
  const isString = typeof tip === 'string'

  return (
    <div
      ref={ref}
      onMouseEnter={toggleMouseHover}
      onMouseLeave={toggleMouseHover}
      className={` flex items-center ${colReverse}  ${className}`}
      data-cy="QuickTip">
      <div className="relative">
        {hover &&
          (isString ? (
            <div
              className={`absolute z-50 bg-white shadow-lg border rounded-md p-3 text-sm w-72 ${positions}`}>
              {tip}
            </div>
          ) : (
            React.cloneElement(tip, {
              className: `absolute z-50 ${positions} ${tip?.props?.className}`,
            })
          ))}
      </div>
      {children}
      {icon}
    </div>
  )
}
